/**
 * Lightweight replacement for `blueimp-load-image` as used in this app:
 * loadImage(file, (canvas) => canvas.toDataURL(...), { orientation: true, canvas: true  })
 *
 * Uses createImageBitmap with EXIF orientation when the browser supports it.
 */
export default function loadImage(fileOrBlob, callback, options = {}) {
  const { orientation = false, canvas: wantCanvas = false } = options

  const finishWithCanvas = (source) => {
    const canvas = document.createElement('canvas')
    canvas.width = source.width
    canvas.height = source.height
    canvas.getContext('2d').drawImage(source, 0, 0)
    if (typeof source.close === 'function') source.close()
    callback(canvas)
  }

  const viaImageElement = () => {
    const reader = new FileReader()
    reader.onload = () => {
      const image = new Image()
      image.onload = () => {
        if (wantCanvas) finishWithCanvas(image)
        else callback(image)
      }
      image.onerror = (event) => callback(event)
      image.src = reader.result
    }
    reader.onerror = (event) => callback(event)
    reader.readAsDataURL(fileOrBlob)
  }

  if (typeof createImageBitmap === 'function') {
    const bitmapOptions = orientation
      ? { imageOrientation: 'from-image' }
      : undefined

    createImageBitmap(fileOrBlob, bitmapOptions)
      .then((bitmap) => {
        if (wantCanvas || orientation) finishWithCanvas(bitmap)
        else {
          // Rare path — callers always pass canvas:true today.
          finishWithCanvas(bitmap)
        }
      })
      .catch(() => viaImageElement())
    return
  }

  viaImageElement()
}
